import React from 'react';
import { css } from 'twin.macro';
import { getInitials, getRandomColor } from '../../../_helpers';
import SelectedPlaceAccessibility from './SelectedPlaceAccessibility';

function MapInfoWindowContent({ infoRenderer, selectedPlace }) {
    return (
        <>
            {typeof infoRenderer === 'function' ? (
                <div
                    css={css`
                        width: 300px;
                        padding: 0.5em;
                    `}
                >
                    {infoRenderer(selectedPlace)}
                </div>
            ) : (
                <div
                    css={css`
                        width: 300px;
                        padding: 0.5em;
                    `}
                >
                    <div
                        css={css`
                            display: flex;
                            flex-direction: column;
                            justify-content: space-between;
                            align-items: center;
                        `}
                    >
                        <div
                            css={css`
                                overflow: hidden;
                                width: 100px;
                                height: 100px;
                                border-radius: 1000px;
                                border: 2px solid #e3e3e3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                color: white;
                                background-color: ${selectedPlace?.teamData?.avatar
                                    ? 'none'
                                    : getRandomColor(selectedPlace?.teamData?._id)};
                                font-weight: 400;
                                font-size: 2.3rem;
                                margin-bottom: 0.5rem;
                            `}
                        >
                            {selectedPlace?.teamData?.avatar ? (
                                <img
                                    css={css`
                                        object-fit: contain;
                                        max-width: 100% !important;
                                    `}
                                    src={selectedPlace?.teamData?.avatar}
                                    alt={selectedPlace?.teamData?.name}
                                />
                            ) : (
                                getInitials(selectedPlace?.teamData?.name)
                            )}
                        </div>
                        <h3
                            className="text-dark"
                            css={css`
                                overflow: hidden;
                                position: relative;
                                word-break: break-all;
                                flex: 1;
                                max-height: 3.6em; /* exactly three lines */
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                margin-bottom: 0.5rem;
                            `}
                        >
                            {selectedPlace?.teamData?.name}
                        </h3>
                        <div
                            css={css`
                                display: flex;
                                align-items: center;
                            `}
                        >
                            <h4
                                className="text-dark mb-0"
                                css={css`
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    overflow-wrap: break-word;
                                    width: 200px;
                                    max-height: 3.6em;
                                    display: -webkit-box;
                                    -webkit-line-clamp: 3;
                                    -webkit-box-orient: vertical;
                                    font-style: italic;
                                    text-align: center;
                                `}
                            >
                                <a href={`teams/${selectedPlace.id}`} rel="noreferrer">
                                    {selectedPlace.title}
                                </a>
                            </h4>
                        </div>
                        <p
                            className="text-dark mb-0"
                            css={css`
                                overflow: hidden;
                                max-height: calc(5 * 1.2em);
                                line-height: 1.2em;
                                display: -webkit-box;
                                -webkit-line-clamp: 3;
                                -webkit-box-orient: vertical;
                                width: 100%;
                                text-align: center;
                                text-overflow: ellipsis;
                            `}
                        >
                            {selectedPlace.name}
                        </p>
                        <p className="text-dark mb-0 mt-2">
                            Go to&nbsp;
                            <b>
                                <a href={`teams/${selectedPlace.id}`} rel="noreferrer">
                                    Channel
                                </a>
                            </b>
                        </p>

                        <SelectedPlaceAccessibility accessibility={selectedPlace?.accessibility} />
                    </div>
                </div>
            )}
        </>
    );
}

export default MapInfoWindowContent;
